_ = require 'underscore'
View = require 'app/scripts/views/internal/view'
sidebarAction = require 'app/scripts/views/templates/card_detail_sidebar_button'

module.exports = class CustomFieldCardButtonView extends View
  tagName: 'span'

  renderOnce: ->
    @$el.html(sidebarAction('js-edit-fields', 'custom-field', 'custom-fields'))
    @
